<mat-form-field class="full-width">
    <mat-label>{{label}}</mat-label>
    @switch (type) {
      @default{
        @if(formControl){
          <input matInput [type]="type" (change)="setValue($event)" (blur)="registerOnTouched($event)" [placeholder]="label" [value]="value" [formControl]="formControl">
        }
        @else{
          <input matInput [type]="type" (change)="setValue($event)" (blur)="registerOnTouched($event)" [placeholder]="label" [value]="value">
        }
      }
      @case('textarea'){
        <textarea matInput (change)="setValue($event)" (blur)="registerOnTouched($event)" [placeholder]="label" [formControl]="formControl"></textarea>
      }
    }
    @if(errorMessage){
      <mat-error>
        {{ errorMessage }}
      </mat-error>
    }
</mat-form-field>


